var map = {
	"./apartment1.jpg": 276,
	"./apartment2.jpg": 277,
	"./apartment3.jpg": 278,
	"./apartment4.jpg": 279,
	"./apartment5.jpg": 280,
	"./hero-1.jpg": 131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;